import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; 
import { FaTags, FaTools } from 'react-icons/fa';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Modifier_tag = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const { tag_id } = location.state || {};
    const navigate = useNavigate(); // Fonction de redirection

    const [tagData, setTagData] = useState({
        titre: '',
        description: '',
        ajoute_par: '',
        statut: 'inactif',  // Initialisation du statut
    });
    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
      if (user_id) {
        document.title = "eTrainApp | Modifier tag"; // Définit le titre de la page
      }
    }, [user_id]);

    const [originalTagData, setOriginalTagData] = useState({}); // Store original data

    // Utilisation de useEffect pour récupérer les données du tag
    useEffect(() => {
        const fetchTagData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/tag-info/${tag_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setTagData({
                        titre: data.titre,
                        description: data.description,
                        ajoute_par: data.ajoute_par,
                        statut: data.statut,
                    });
                    setOriginalTagData({ // Store original data for reset
                        titre: data.titre,
                        description: data.description,
                        ajoute_par: data.ajoute_par,
                        statut: data.statut,
                    });
                } else {
                    console.error('Erreur lors de la récupération des données du tag');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchTagData();
    }, [tag_id]);

    // Fonction de soumission du formulaire
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = {
            titre: tagData.titre,
            description: tagData.description,
            statut: tagData.statut,
        };
        console.log('Je suis là',formData)

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-tag/${tag_id}/`, {
                method: 'PUT', // Utilisation de PUT pour modifier le tag
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                // Redirection vers la liste des tags après la réussite
                // alert("Tag modifié avec succès !");
                navigate(`/Liste-tag`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Fonction pour annuler et remettre à zéro les champs
    const handleCancel = () => {
        setTagData(originalTagData); // Reset to original data
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                            <h2><FaTags size={25} className='mr-2'/> Modification du Tag {originalTagData.nom}</h2>
                            <small>Administration des Tags.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-tag`}>Tags</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Modification du Tag {originalTagData.titre}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="col-6 mx-auto m-4 p-5">
                        <div className="ibox-content">
                            <div className="hpanel">
                                <div className="panel-body">
                                    <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                        <div className="">
                                            <div className="form-group">
                                                <label>Titre <strong style={{color: 'red'}}>*</strong></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    required
                                                    name="titre"
                                                    value={tagData.titre || ''} // Ajout d'une valeur par défaut si les données ne sont pas encore chargées
                                                    onChange={(e) => setTagData({ ...tagData, titre: e.target.value })}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Description</label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    name="description"
                                                    value={tagData.description || ''}
                                                    onChange={(e) => setTagData({ ...tagData, description: e.target.value })}
                                                ></textarea>
                                            </div>

                                            {/* <div className="form-group">
                                                <label>Statut <strong style={{color: 'red'}}>*</strong></label>
                                                <select
                                                    className="form-control m-b"
                                                    name="statut"
                                                    value={tagData.statut || 'inactif'}
                                                    onChange={(e) => setTagData({ ...tagData, statut: e.target.value })}
                                                >
                                                    <option value="inactif">Inactif</option>
                                                    <option value="actif">Actif</option>
                                                </select>
                                            </div> */}
                                        </div>
                                        <div className="text-center mt-5">
                                            <a href='/Liste-tag' className="btn btn-default mr-2">Annuler</a>
                                            <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                            <button type="submit" className="btn btn-success">Enregistrer</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modifier_tag;


// import React, { useState, useEffect } from 'react';
// import Header from '../../dashboard/header';
// import Navbar from '../../dashboard/navbar';
// import Sidebar from '../../dashboard/sidebar';
// import { useLocation, useParams, useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import useAuth from '../../dashboard/useAuth';

// const Modifier_tag = ({ titre }) => {
//     useAuth();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);

//     const user_id = localStorage.getItem('user_id');
//     const { tag_id } = location.state || {};
//     // const { tag_id } = useParams();
//     const navigate = useNavigate();

//     const [tagData, setTagData] = useState({
//         titre: '',
//         description: '',
//         statut: 'inactif',
//     });

//     useEffect(() => {
//         if (user_id) {
//             document.title = "eTrainApp | Modifier Tag";
//         }
//     }, [user_id]);

//     const [originalTagData, setOriginalTagData] = useState({});

//     useEffect(() => {
//         const fetchTagData = async () => {
//             try {
//                 const response = await fetch(process.env.REACT_APP_HOTE + `/tag-info/${tag_id}/`);
//                 if (response.ok) {
//                     const data = await response.json();
//                     setTagData({
//                         titre: data.titre,
//                         description: data.description,
//                         statut: data.statut,
//                         ajoute_par: data.ajoute_par,
//                     });
//                     setOriginalTagData({
//                         titre: data.titre,
//                         description: data.description,
//                         statut: data.statut,
//                         ajoute_par: data.ajoute_par,
//                     });
//                 } else {
//                     console.error('Erreur lors de la récupération des données du tag');
//                 }
//             } catch (error) {
//                 console.error('Erreur réseau:', error);
//             }
//         };

//         fetchTagData();
//     }, [tag_id]);

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         const formData = {
//             titre: tagData.titre,
//             description: tagData.description,
//             statut: tagData.statut,
//         };

//         try {
//             const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-tag/${tag_id}/`, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (!response.ok) {
//                 const errorData = await response.json();
//                 console.error('Erreur:', errorData);
//             } else {
//                 const data = await response.json();
//                 console.log('Succès:', data);
//                 navigate(`/Liste-tag`);
//             }
//         } catch (error) {
//             console.error('Erreur réseau:', error);
//         }
//     };

//     const handleCancel = () => {
//         setTagData(originalTagData);
//     };

//     return (
//         <div id="wrapper">
//             <Sidebar user_id={user_id} titre={titre} />
//             <div id="page-wrapper" className="gray-bg">
//                 <Navbar />
//                 <div>
//                     <div className="row wrapper border-bottom white-bg page-heading">
//                         <div className="col-lg-12">
//                             <h2>Modification du Tag : {originalTagData.titre}</h2>
//                             <ol className="breadcrumb custom-breadcrumb">
//                                 <li className="breadcrumb-item custom-breadcrumb-item">
//                                     <Link to={`/dashboard`}>Dashboard</Link>
//                                 </li>
//                                 <li className="breadcrumb-item custom-breadcrumb-item">
//                                     <Link to={`/admin`}>Administration</Link>
//                                 </li>
//                                 <li className="breadcrumb-item custom-breadcrumb-item">
//                                     <Link to={`/Liste-tag`}>Tags</Link>
//                                 </li>
//                                 <li className="breadcrumb-item custom-breadcrumb-item">
//                                     <Link to={`/Modifier-tag`}>Modification du Tag</Link>
//                                 </li>
//                             </ol>
//                         </div>
//                     </div>
//                     <div className="col-6 mx-auto m-4 p-5">
//                         <div className="ibox-content">
//                             <div className="hpanel">
//                                 <div className="panel-body">
//                                     <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
//                                         <div className="">
//                                             <div className="form-group">
//                                                 <label>Titre*</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     placeholder=""
//                                                     required
//                                                     name="titre"
//                                                     value={tagData.titre || ''}
//                                                     onChange={(e) => setTagData({ ...tagData, titre: e.target.value })}
//                                                 />
//                                             </div>
//                                             <div className="form-group">
//                                                 <label>Description</label>
//                                                 <textarea
//                                                     className="form-control"
//                                                     placeholder=""
//                                                     name="description"
//                                                     value={tagData.description || ''}
//                                                     onChange={(e) => setTagData({ ...tagData, description: e.target.value })}
//                                                 ></textarea>
//                                             </div>
//                                             <div className="form-group">
//                                                 <label>Statut*</label>
//                                                 <select
//                                                     className="form-control m-b"
//                                                     name="statut"
//                                                     value={tagData.statut || 'inactif'}
//                                                     onChange={(e) => setTagData({ ...tagData, statut: e.target.value })}
//                                                 >
//                                                     <option value="inactif">Inactif</option>
//                                                     <option value="actif">Actif</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="text-center mt-5">
//                                             <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Annuler</button>
//                                             <button type="submit" className="btn btn-success">Enregistrer</button>
//                                         </div>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Modifier_tag;
